export default __webpack_public_path__ + "static/media/TDSA_1.9c77ad51.jpg";